// -----------------------------------------------------------------------------
// Library
// -----------------------------------------------------------------------------
import React, { useCallback } from "react";
import { Card, Typography } from "antd";
import { SketchPicker } from "react-color";

// -----------------------------------------------------------------------------
// Components, utils and Styles
// -----------------------------------------------------------------------------

import { SelectedColorCard } from "components/Common/Cards/SelectedColorCard";
import StyledColorPickerCard from "./styles";

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------
const ColorPickerCard = ({ title, subtitle, selectedColor, description, onChangeColor }) => {
	const handleChangeComplete = useCallback(
		(e) => {
			onChangeColor(e.hex);
		},
		[onChangeColor]
	);

	return (
		<StyledColorPickerCard>
			<Card hoverable className="sb-color-picker-card">
				<div className="sb-color-picker-card__left">
					<Typography.Title level={4} className="sb-color-picker-card__left__title">
						{title}
					</Typography.Title>
					<Typography.Paragraph className="sb-color-picker-card__left__subtitle">{subtitle}</Typography.Paragraph>
					<Typography.Paragraph className="sb-color-picker-card__left__description">{description}</Typography.Paragraph>
					<div className="sb-color-picker-card__left__current-color">
						<SelectedColorCard selectedColor={selectedColor} />
					</div>
				</div>
				<div className="sb-color-picker-card__right">
					<SketchPicker color={selectedColor || ""} onChangeComplete={handleChangeComplete} />
				</div>
			</Card>
		</StyledColorPickerCard>
	);
};

export default ColorPickerCard;

